import HeaderSection from '../../../components/Header/HeaderSection';


export default function HistoryText() {

    
    return (

        <HeaderSection

            headline_p1 = "Know your" 
            headline_grey = "family history - "
            headline_p2 = "deseases"

            text1 = "If a health condition runs in your family, you may have a higher risk of developing it than to the general population."
            text2 = "If you are aware of family health conditions, your doctor can provide regular check-ups, early treatment and suggest lifestyle changes to protect your health."

        />

            
    )
}